module.exports = __webpack_public_path__ + "static/media/noSearchResult.08402118.svg";